import { useRef, useState } from "react";
import "./index.scss";

export const SellSearchItem = ({
  focused,
  name,
  image_url,
  onClick,
  onHover,
  value
}) => {
  const touchStartYRef = useRef(null);
  const [imageError, setImageError] = useState(null);

  const handleClick = () => onClick(name, true);

  // save touch initial position
  const onTouchStart = (e) => {
    touchStartYRef.current = e.touches[0].clientY;
  };

  // logic to determine whether it is a click or a scroll
  const onTouchEnd = (e) => {
    if (touchStartYRef.current !== null) {
      const touchEndY = e.changedTouches[0].clientY;
      const diffY = Math.abs(touchEndY - touchStartYRef.current);
      const scrollThreshold = 10;

      if (diffY < scrollThreshold) {
        handleClick();
      }
    }
    touchStartYRef.current = null;
  };

  return (
    <li name={name}>
      <button
        className={`sell-search-item ${focused && "focused"}`}
        type="button"
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
        onClick={handleClick}
        onMouseEnter={onHover}
      >
        {!imageError && (
          <img src={image_url} alt="brand" onError={setImageError} />
        )}
        <p>{value}</p>
      </button>
    </li>
  );
};
